const initState = null;

const viewFromAgentId = (state = initState, action) => {
    switch (action.type) {
        case 'SET_VIEW_FROM_AGENT_ID':
            state = action.agentId;
            return state;
        default: return state;
    }
};

export default viewFromAgentId;